import FileDropzone from './FileDropzone';
export default FileDropzone;
